import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { finagoTimeEventTypesQuery } from '../../../../../api/index.js'

export const useGetFinagoTimeEventTypesOptions = () => {
	const { i18n } = useTranslation()
	const lang = (i18n.resolvedLanguage ?? 'fi').split('-')[0]
	const { data, isLoading, isError } = useQuery(finagoTimeEventTypesQuery)

	const options = useMemo(() => {
		if (!data) return []
		return data.map((eventType) => {
			let label = eventType.nameFi
			if (lang === 'sv' && eventType.nameSv) label = eventType.nameSv
			else if (lang === 'en' && eventType.nameEn) label = eventType.nameEn

			return {
				value: String(eventType.id),
				label,
				paidness: 'Other',
			}
		})
	}, [data, lang])

	return { options, isLoading, isError }
}
